import React from "react";
import Select from "react-select";
import { ROLES } from "../../../constants/roles";

const MangerSelect = React.memo(function MangerSelect({ value, onChange, users, isDisabled }) {
  const usersOptions =
    users && users.length > 0
      ? users
          ?.filter((user) => user.role == ROLES.MANAGER)
          .map((user) => ({
            value: user.id,
            label: user.name,
          }))
      : [];

  const selectedManager = usersOptions?.find((option) => option.value === value) || null;

  const handleChange = (selectedOption) => {
    onChange(selectedOption ? selectedOption.value : null);
  };

  return (
    <div>
      <label htmlFor="maintenance_manager_id">اختر المدير</label>
      <Select
        value={selectedManager}
        options={usersOptions}
        onChange={handleChange}
        id="maintenance_manager_id"
        placeholder="اختر المدير"
        isSearchable
        isDisabled={isDisabled}
        isClearable
        classNames={{
          control: (state) => (state.isFocused ? "selectSearchFocus" : "selectSearch"),
        }}
      />
    </div>
  );
});

export default MangerSelect;
